import Vue from "vue";
import {i18n} from "../locales/i18n";
import {pages} from "../constants/pages";

export function resolveErrorMessage(error) {
  let code = "B23";
  let message = "unknown_error";
  if(error.response.data.error.startsWith("B")) {
       code = getCode(error.response.data.error);
       message = getMessage(error.response.data.error, code);

  } else if (error.response.data.code === 422) {
       code = "B6";
       message = "invalid_input";
  }
    return  {
        message: Vue.options.filters.capitalize(i18n.t(pages.alerts[message])),
        code: i18n.t(pages.alerts.error_code)+" "+code
    }
}

export function handleApiErrors(error) {
  const errorBody = resolveErrorMessage(error);
  Vue.$snotify.error(errorBody.message, errorBody.code);
}
function getCode (error) {
  return error.split('_')[0];
}
function getMessage (error, code) {
  return error.slice(code.length+1);
}

